var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrentWeatherIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 158.914L95.4086 152.82C101.546 145.791 107.066 139.123 111.977 132.78L116.031 127.431C132.96 104.623 141.429 86.5199 141.429 73.1399C141.429 44.5799 118.406 21.4285 90 21.4285C61.5943 21.4285 38.5714 44.5799 38.5714 73.1399C38.5714 86.5199 47.04 104.623 63.9686 127.431L68.0229 132.78C75.0295 141.758 82.36 150.469 90 158.914Z",
    stroke: "white",
    strokeWidth: 8.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94.2856C101.835 94.2856 111.429 84.6917 111.429 72.857C111.429 61.0224 101.835 51.4285 90 51.4285C78.1653 51.4285 68.5714 61.0224 68.5714 72.857C68.5714 84.6917 78.1653 94.2856 90 94.2856Z",
    stroke: "white",
    strokeWidth: 8.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentWeatherIcon);
export default __webpack_public_path__ + "static/media/current_weather_icon.0a0576eae63d71c67aa8aea705a5d2b4.svg";
export { ForwardRef as ReactComponent };